
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ShellStateService } from '../shell-state.service';

@Component({
    selector: 'app-share-doc-details',
    imports: [
    TranslateModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    MatDividerModule,
    MatButtonModule
],
    templateUrl: './share-doc-details.component.html',
    styleUrl: './share-doc-details.component.scss'
})
export class ShareDocDetailsComponent implements OnInit {

  @Input() docId: string = '';
  @Input() docType: string = '';
  @Input() docName: string = '';
  @Input() created: Date = new Date(0);
  @Input() nViews: number = 0;
  @Input() nCopies: number = 0;
  @Input() nSharedPeople: number = 0;
  @Input() publicShareType: string = '';

  public descViews: string = '';
  public descCopies: string = '';
  public descPeopleShared: string = '';
  public iconShareType: string = '';
  public descShareType: string = '';

  constructor(
    public shellStateService: ShellStateService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    const sCreated = this.created.toLocaleDateString(this.translateService.currentLang, { day: 'numeric', month: 'short', year: 'numeric' });
    this.descViews = this.translateService.instant('SHARE_DETAILS_VIEWS').replace('{1}', this.nViews).replace('{2}', sCreated);
    this.descCopies = this.translateService.instant('SHARE_DETAILS_COPIES').replace('{1}', this.nCopies).replace('{2}', sCreated);
    this.descPeopleShared = this.translateService.instant('SHARE_DETAILS_PEOPLE').replace('{1}', this.nSharedPeople);
    let keyDesc = '';
    switch (this.publicShareType) {
      case 'none':
        this.iconShareType = 'lock';
        keyDesc = 'PUBLIC_SHARE_LIMIT_ONLY_PERMISSION_DESCRIPTION';
        break;
      case 'view':
        this.iconShareType = 'visibility';
        keyDesc = 'PUBLIC_SHARE_VIEW_ONLY_PERMISSION_DESCRIPTION';
        break;
      case 'edit':
        this.iconShareType = 'edit';
        keyDesc = 'PUBLIC_SHARE_EDIT_PERMISSION_DESCRIPTION';
        break;
    }
    this.descShareType = this.translateService.instant(keyDesc);
  }


}
